import * as THREE from '../../libs/three.js/build/three.module.js';
import { TextSprite } from '../TextSprite.js';
import { Line2 } from '../../libs/three.js/lines/Line2.js';
import { LineGeometry } from '../../libs/three.js/lines/LineGeometry.js';
import { LineMaterial } from '../../libs/three.js/lines/LineMaterial.js';
import * as SharedUtils from './SharedUtils.js';

function createHeightLine() {
  let lineGeometry = new LineGeometry();

  lineGeometry.setPositions([0, 0, 0, 0, 0, 0]);

  let lineMaterial = new LineMaterial({
    color: 0x00ff00,
    dashSize: 5,
    gapSize: 2,
    linewidth: 2,
    resolution: new THREE.Vector2(1000, 1000),
  });

  lineMaterial.depthTest = false;
  const heightEdge = new Line2(lineGeometry, lineMaterial);
  heightEdge.visible = false;

  //this.add(this.heightEdge);

  return heightEdge;
}

function createHeightLabel() {
  const heightLabel = new TextSprite('');

  heightLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
  heightLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  heightLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
  heightLabel.fontsize = 16;
  heightLabel.material.depthTest = false;
  heightLabel.material.opacity = 1;
  heightLabel.visible = false;

  return heightLabel;
}

function createAreaLabel() {
  const areaLabel = new TextSprite('');

  areaLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
  areaLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  areaLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
  areaLabel.fontsize = 16;
  areaLabel.material.depthTest = false;
  areaLabel.material.opacity = 1;
  areaLabel.visible = false;

  return areaLabel;
}

function createtotalDistanceLabel() {
  const totalDistanceLabel = new TextSprite('');

  totalDistanceLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
  totalDistanceLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  totalDistanceLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
  totalDistanceLabel.fontsize = 16;
  totalDistanceLabel.material.depthTest = false;
  totalDistanceLabel.material.opacity = 1;
  totalDistanceLabel.visible = false;

  return totalDistanceLabel;
}

function createCircleRadiusLabel() {
  const circleRadiusLabel = new TextSprite('');

  circleRadiusLabel.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
  circleRadiusLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
  circleRadiusLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
  circleRadiusLabel.fontsize = 16;
  circleRadiusLabel.material.depthTest = false;
  circleRadiusLabel.material.opacity = 1;
  circleRadiusLabel.visible = false;

  return circleRadiusLabel;
}

function createCircleRadiusLine() {
  const lineGeometry = new LineGeometry();

  lineGeometry.setPositions([0, 0, 0, 0, 0, 0]);

  const lineMaterial = new LineMaterial({
    color: 0xff0000,
    linewidth: 2,
    resolution: new THREE.Vector2(1000, 1000),
    gapSize: 1,
    dashed: true,
  });

  lineMaterial.depthTest = false;

  const circleRadiusLine = new Line2(lineGeometry, lineMaterial);
  circleRadiusLine.visible = false;

  return circleRadiusLine;
}

function createCircleLine() {
  const coordinates = [];

  let n = 128;
  for (let i = 0; i <= n; i++) {
    let u0 = 2 * Math.PI * (i / n);
    let u1 = (2 * Math.PI * (i + 1)) / n;

    let p0 = new THREE.Vector3(Math.cos(u0), Math.sin(u0), 0);

    let p1 = new THREE.Vector3(Math.cos(u1), Math.sin(u1), 0);

    coordinates.push(...p0.toArray(), ...p1.toArray());
  }

  const geometry = new LineGeometry();
  geometry.setPositions(coordinates);

  const material = new LineMaterial({
    color: 0xff0000,
    dashSize: 5,
    gapSize: 2,
    linewidth: 2,
    resolution: new THREE.Vector2(1000, 1000),
  });

  material.depthTest = false;

  const circleLine = new Line2(geometry, material);
  circleLine.visible = false;
  circleLine.computeLineDistances();

  return circleLine;
}

function createCircleCenter() {
  const sg = new THREE.SphereGeometry(1, 32, 32);
  const sm = new THREE.MeshLambertMaterial({ color: 0xff0000, emissive: 0x000000 });

  const circleCenter = new THREE.Mesh(sg, sm);
  circleCenter.visible = false;

  return circleCenter;
}

function createLine() {
  const geometry = new LineGeometry();

  geometry.setPositions([0, 0, 0, 0, 0, 0]);

  const material = new LineMaterial({
    color: 0xff0000,
    linewidth: 2,
    resolution: new THREE.Vector2(1000, 1000),
    gapSize: 1,
    dashed: true,
  });

  material.depthTest = false;

  const line = new Line2(geometry, material);

  return line;
}

function createCircle() {
  const coordinates = [];

  let n = 128;
  for (let i = 0; i <= n; i++) {
    let u0 = 2 * Math.PI * (i / n);
    let u1 = (2 * Math.PI * (i + 1)) / n;

    let p0 = new THREE.Vector3(Math.cos(u0), Math.sin(u0), 0);

    let p1 = new THREE.Vector3(Math.cos(u1), Math.sin(u1), 0);

    coordinates.push(...p0.toArray(), ...p1.toArray());
  }

  const geometry = new LineGeometry();
  geometry.setPositions(coordinates);

  const material = new LineMaterial({
    color: 0xff0000,
    dashSize: 5,
    gapSize: 2,
    linewidth: 2,
    resolution: new THREE.Vector2(1000, 1000),
  });

  material.depthTest = false;

  const line = new Line2(geometry, material);
  line.computeLineDistances();

  return line;
}

function createAzimuth() {
  const azimuth = {
    label: null,
    northLabel: null,
    center: null,
    target: null,
    north: null,
    centerToNorth: null,
    centerToTarget: null,
    centerToTargetground: null,
    targetgroundToTarget: null,
    circle: null,

    node: null,
  };

  const sg = new THREE.SphereGeometry(1, 32, 32);

  {
    const label = new TextSprite('');
    label.setTextColor({ r: 140, g: 250, b: 140, a: 1.0 });
    label.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
    label.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
    label.fontsize = 16;
    label.material.depthTest = false;
    label.material.opacity = 1;
    azimuth.label = label;
  }

  {
    const northLabel = new TextSprite('N');
    northLabel.setTextColor({ r: 255, g: 255, b: 255, a: 1.0 });
    northLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
    northLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 0.6 });
    northLabel.fontsize = 16;
    northLabel.material.depthTest = false;
    northLabel.material.opacity = 1;
    azimuth.northLabel = northLabel;
  }

  azimuth.center = new THREE.Mesh(sg, new THREE.MeshLambertMaterial({ color: 0xff0000, emissive: 0x000000 }));
  azimuth.target = new THREE.Mesh(sg, new THREE.MeshLambertMaterial({ color: 0xff0000, emissive: 0x000000 }));
  azimuth.north  = new THREE.Mesh(sg, new THREE.MeshLambertMaterial({ color: 0xffffff, emissive: 0x333333 }));
  azimuth.centerToNorth = createLine();
  azimuth.centerToTarget = createLine();
  azimuth.centerToTargetground = createLine();
  azimuth.targetgroundToTarget = createLine();
  azimuth.circle = createCircle();

  azimuth.node = new THREE.Object3D();
  azimuth.node.add(
    azimuth.centerToNorth,
    azimuth.centerToTarget,
    azimuth.centerToTargetground,
    azimuth.targetgroundToTarget,
    azimuth.circle,
    azimuth.label,
    azimuth.northLabel,
    azimuth.center,
    azimuth.target,
    azimuth.north
  );

  return azimuth;
}

export class Measure extends THREE.Object3D {
  constructor() {
    super();

    this.constructor.counter =
      this.constructor.counter === undefined ? 0 : this.constructor.counter + 1;

    // defaults
    this.name = 'Measure_' + this.constructor.counter;
    this.points = [];
    this._showDistances = true;
    this._showCoordinates = false;
    this._showArea = false;
    this._showTotalDistance = false;
    this._closed = true;
    this._showAngles = false;
    this._showCircle = false;
    this._showHeight = false;
    this._showEdges = true;
    this._showAzimuth = false;
    this.maxMarkers = Number.MAX_SAFE_INTEGER;
    this.isOverSphere = false;
    this.sphereDragged = undefined;
    
    // Axis locking state
    this.lockedX = false;
    this.lockedY = false;
    this.lockedZ = false;

    this.sphereGeometry = new THREE.SphereGeometry(0.4, 10, 10);
    this.color = new THREE.Color(0xff0000);

    this.spheres = [];
    this.edges = [];
    this.sphereLabels = [];
    this.edgeLabels = [];
    this.angleLabels = [];
    this.coordinateLabels = [];
    /** [dx,dy,dz] added to scene XYZ on coordinate labels. Set by MeasuringTool. */
    this.displayCoordOffset = null;

    this.heightEdge = createHeightLine();
    this.heightLabel = createHeightLabel();
    this.baseLabel = createHeightLabel();
    this.areaLabel = createAreaLabel();
    this.totalDistanceLabel = createtotalDistanceLabel();
    this.circleRadiusLabel = createCircleRadiusLabel();
    this.circleRadiusLine = createCircleRadiusLine();
    this.circleLine = createCircleLine();
    this.circleCenter = createCircleCenter();

    this.azimuth = createAzimuth();

    this._folder = null;

    this.add(this.heightEdge);
    this.add(this.heightLabel);
    this.add(this.baseLabel);
    this.add(this.areaLabel);
    this.add(this.totalDistanceLabel);
    this.add(this.circleRadiusLabel);
    this.add(this.circleRadiusLine);
    this.add(this.circleLine);
    this.add(this.circleCenter);

    this.add(this.azimuth.node);
  }

  get folder() {
    return this._folder;
  }

  set folder(folder) {
    this._folder = folder;
  }

  createSphereMaterial() {
    return new THREE.MeshLambertMaterial({
      color: this.color,
      emissive: 0x000000
    });
  }

  /** Dot color by snap target: cloud=red, mesh=green, BIM=light blue. */
  static colorForSnapSource(source) {
    if (source === 'bim') return new THREE.Color(0x7dd3fc);
    if (source === 'realityMesh') return new THREE.Color(0x22c55e);
    if (source === 'pointCloud') return new THREE.Color(0xef4444);
    return null;
  }

  sphereColorForPoint(point) {
    return Measure.colorForSnapSource(point?.snapSource) || this.color;
  }

  updateColor() {
    const c = this.color;
    for (let i = 0; i < this.spheres.length; i++) {
      const snap = Measure.colorForSnapSource(this.points[i]?.snapSource);
      this.spheres[i].material.color.copy(snap || c);
    }
    for (const edge of this.edges) {
      edge.material.color.copy(c);
      edge.material.needsUpdate = true;
    }
    this.heightEdge.material.color.copy(c);
    this.heightEdge.material.needsUpdate = true;
    this.circleLine.material.color.copy(c);
    this.circleLine.material.needsUpdate = true;
    this.circleRadiusLine.material.color.copy(c);
    this.circleRadiusLine.material.needsUpdate = true;
    this.circleCenter.material.color.copy(c);
    if (this.azimuth) {
      this.azimuth.center.material.color.copy(c);
      this.azimuth.target.material.color.copy(c);
      // azimuth.north stays white intentionally
      for (const line of [
        this.azimuth.centerToNorth,
        this.azimuth.centerToTarget,
        this.azimuth.centerToTargetground,
        this.azimuth.targetgroundToTarget,
        this.azimuth.circle,
      ]) {
        line.material.color.set(c);
        line.material.needsUpdate = true;
      }
    }
  }

  addMarker(point) {
    if (point.x != null) {
      point = { position: point };
    } else if (point instanceof Array) {
      point = { position: new THREE.Vector3(...point) };
    }
    
    this.points.push(point);

    // sphere
    let sphere = new THREE.Mesh(
      this.sphereGeometry,
      this.createSphereMaterial()
    );
    const snapColor = Measure.colorForSnapSource(point.snapSource);
    if (snapColor) sphere.material.color.copy(snapColor);

    this.add(sphere);
    this.spheres.push(sphere);

    {
      // edges
      this.createEdge(this._closed);
    }

    {
      // edge labels
      this.createEdgeLabel();
    }

    {
      // angle labels
      this.createAngleLabel();
    }

    {
      // coordinate labels
      this.createCoordinateLabel();
    }

    {
      // Event Listeners
      let drag = (e) => {
        let applyPick = (I) => {
          let i = this.spheres.indexOf(e.drag.object);
          if (i !== -1) {
            this.applyPickToMarker(i, I);
          }
        };

        // Dragging is the only thing that positions a marker on desktop, and it
        // stops firing while the pointer is held still to aim — so the BIM answer
        // is applied late as well, or the click commits a pre-BIM guess.
        applyPick(
          SharedUtils.getMousePointCloudIntersectionSettling(
            e.drag.end,
            e.viewer.scene.getActiveCamera(),
            e.viewer,
            e.viewer.scene.pointclouds,
            { pickClipped: true },
            applyPick
          )
        );
      };

      let drop = (e) => {
        let i = this.spheres.indexOf(e.drag.object);
        if (i !== -1) {
          this.dispatchEvent({
            type: 'marker_dropped',
            measurement: this,
            index: i,
          });
        }
      };

      let mouseup = (event) => {
        let i = this.spheres.indexOf(event.target);
        if (i === -1) {
          return;
        }
        this.removeMarker(i);
      };

      // Neutral, because a dragged marker stays under the cursor: a tinted
      // highlight would hide the snap-source colour for the whole drag, which is
      // when it is actually needed to tell what the point is being pulled onto.
      let mouseover = (e) => {
        this.isOverSphere = true;
        e.object.material.emissive.setHex(0x555555);
      };

      let mouseleave = (e) => {
        this.isOverSphere = false;
        e.object.material.emissive.setHex(0x000000);
      };


      sphere.addEventListener('drag', drag);
      sphere.addEventListener('drop', drop);
      sphere.addEventListener('mouseover', mouseover);
      sphere.addEventListener('mouseleave', mouseleave);
      sphere.addEventListener('mouseup', (event) => {
        if (event.button !== THREE.MOUSE.MIDDLE) {
          return;
        }
        if (this.sphereDragged !== undefined) {
          return;
        }
        mouseup(event);
      });
    }

    let event = {
      type: 'marker_added',
      measurement: this,
      sphere: sphere,
    };
    this.dispatchEvent(event);

    this.setMarker(this.points.length - 1, point);
  }

  createEdge(isClosed) {
    let lineGeometry = new LineGeometry();
    lineGeometry.setPositions([0, 0, 0, 0, 0, 0]);

    let lineMaterial = new LineMaterial({
      color: 0xff0000,
      linewidth: 2,
      resolution: new THREE.Vector2(1000, 1000),
    });

    lineMaterial.depthTest = false;

    let edge = new Line2(lineGeometry, lineMaterial);
    edge.visible = true;

    this.add(edge);
    this.edges.push(edge);
  }

  createEdgeLabel() {
    let edgeLabel = new TextSprite();
    edgeLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
    edgeLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
    edgeLabel.material.depthTest = false;
    edgeLabel.visible = false;
    edgeLabel.fontsize = 16;
    this.edgeLabels.push(edgeLabel);
    this.add(edgeLabel);
  }

  createAngleLabel() {
    let angleLabel = new TextSprite();
    angleLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
    angleLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
    angleLabel.fontsize = 16;
    angleLabel.material.depthTest = false;
    angleLabel.material.opacity = 1;
    angleLabel.visible = false;
    this.angleLabels.push(angleLabel);
    this.add(angleLabel);
  }

  createCoordinateLabel() {
    let coordinateLabel = new TextSprite();
    coordinateLabel.setBorderColor({ r: 0, g: 0, b: 0, a: 1.0 });
    coordinateLabel.setBackgroundColor({ r: 0, g: 0, b: 0, a: 1.0 });
    coordinateLabel.fontsize = 16;
    coordinateLabel.material.depthTest = false;
    coordinateLabel.material.opacity = 1;
    coordinateLabel.visible = false;
    this.coordinateLabels.push(coordinateLabel);
    this.add(coordinateLabel);
  }

  connectEdges(index, nextPoint, point, isClosed, lastIndex) {
    let edge = this.edges[index];

    if (edge === undefined || edge === null) {
      return;
    }
    edge.material.color = this.color;

    edge.position.copy(point.position);

    edge.geometry.setPositions([
      0,
      0,
      0,
      ...nextPoint.position.clone().sub(point.position).toArray(),
    ]);

    edge.geometry.verticesNeedUpdate = true;
    edge.geometry.computeBoundingSphere();
    edge.computeLineDistances();
    edge.visible = index < lastIndex || this.closed;

    if (!this.showEdges) {
      edge.visible = false;
    }
  }

  addEdgeLabel(index, lastIndex, nextPoint, point) {
    if (nextPoint === undefined || point === undefined) {
      return;
    }
    let edgeLabel = this.edgeLabels[index];
    let center = new THREE.Vector3().add(point.position);
    center.add(nextPoint.position);
    center = center.multiplyScalar(0.5);
    let distance = point.position.distanceTo(nextPoint.position);

    edgeLabel.position.copy(center);

    let suffix = '';
    if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
      distance =
        (distance / this.lengthUnit.unitspermeter) *
        this.lengthUnitDisplay.unitspermeter; //convert to meters then to the display unit
      suffix = this.lengthUnitDisplay.code;
    }

    let txtLength = SharedUtils.addCommas(distance.toFixed(2));
    edgeLabel.setText(`${txtLength} ${suffix}`);
    edgeLabel.visible =
      this.showDistances &&
      (index < lastIndex || this.closed) &&
      this.points.length >= 2 &&
      distance > 0;
  }

  removeMarker(index) {
    this.points.splice(index, 1);
    this.coordinateLabels.splice(index, 1);

    this.remove(this.spheres[index]);

    let hasEdges = this.edges.length > 0 ? true : false;

    for (let i = 0; i < this.edges.length; i++) {
      this.remove(this.edges[i]);
    }
    this.edges = [];
    for (let i = 0; i < this.edgeLabels.length; i++) {
      this.remove(this.edgeLabels[i]);
    }
    this.edgeLabels = [];

    for (let i = 0; i < this.angleLabels.length; i++) {
      this.remove(this.angleLabels[i]);
    }
    this.angleLabels = [];

    this.spheres.splice(index, 1);

    if (
      (this.points.length === 2 && this._closed) ||
      (this.points.length === 1 && hasEdges && !this._closed)
    ) {
      let length = this.points.length;
      for (let i = 0; i < length; i++) {
        this.points.splice(0, 1);
        this.coordinateLabels.splice(0, 1);

        this.remove(this.spheres[i]);

        for (let j = 0; j < this.edges.length; j++) {
          this.remove(this.edges[j]);
        }
        this.edges = [];
        for (let j = 0; j < this.edgeLabels.length; j++) {
          this.remove(this.edgeLabels[j]);
        }
        this.edgeLabels = [];

        for (let j = 0; j < this.angleLabels.length; j++) {
          this.remove(this.angleLabels[j]);
        }
        this.angleLabels = [];

        this.spheres.splice(0, 1);
      }
      return;
    }

    for (let i = 1; i < this.points.length; i++) {
      this.createEdge(this._closed);
      this.connectEdges(
        i - 1,
        this.points[i],
        this.points[i - 1],
        this._closed,
        this.points.length
      );
    }
    if (this._closed) {
      this.createEdge(this._closed);
      this.connectEdges(
        this.points.length - 1,
        this.points[0],
        this.points[this.points.length - 1],
        this._closed,
        this.points.length
      );
    }
    for (let i = 0; i < this.edges.length; i++) {
      this.createEdgeLabel();
    }

    if (this._closed) {
      for (let i = 0; i < this.edges.length; i++) {
        if (i + 1 >= this.edges.length) {
          this.addEdgeLabel(
            i,
            this.edges.length - 1,
            this.points[0],
            this.points[i]
          );
        } else {
          this.addEdgeLabel(
            i,
            this.edges.length - 1,
            this.points[i + 1],
            this.points[i]
          );
        }
      }
    } else {
      for (let i = 0; i < this.edges.length; i++) {
        this.addEdgeLabel(
          i,
          this.edges.length - 1,
          this.points[i + 1],
          this.points[i]
        );
      }
    }

    for (let i = 0; i < this.points.length; i++) {
      this.createAngleLabel();
    }

    this.update();

    this.dispatchEvent({ type: 'marker_removed', measurement: this });
  }

  setMarker(index, point) {
    this.points[index] = point;

    let event = {
      type: 'marker_moved',
      measure: this,
      index: index,
      position: point.position.clone(),
    };
    this.dispatchEvent(event);

    this.update();
  }

  setPosition(index, position) {
    let point = this.points[index];
    point.position.copy(position);

    let event = {
      type: 'marker_moved',
      measure: this,
      index: index,
      position: position.clone(),
    };
    this.dispatchEvent(event);

    this.update();
  }

  /** Apply a unified pick (point cloud / mesh / BIM) to an existing marker. */
  applyPickToMarker(index, I) {
    if (!I || index < 0 || index >= this.points.length) {
      return;
    }

    let point = this.points[index];
    const picked = I.point || { position: I.location };

    for (let key of Object.keys(point)) {
      if (key === 'snapSource') continue;
      if (!picked[key]) {
        delete point[key];
      }
    }

    for (let key of Object.keys(picked).filter((k) => k !== 'position')) {
      point[key] = picked[key];
    }

    if (I.source) {
      point.snapSource = I.source;
    } else {
      delete point.snapSource;
    }

    let newPosition = I.location.clone();
    let currentPosition = point.position.clone();

    if (this.lockedX) {
      newPosition.x = currentPosition.x;
    }
    if (this.lockedY) {
      newPosition.y = currentPosition.y;
    }
    if (this.lockedZ) {
      newPosition.z = currentPosition.z;
    }

    this.setPosition(index, newPosition);

    const snapColor = Measure.colorForSnapSource(point.snapSource);
    const sphere = this.spheres[index];
    if (sphere?.material?.color) {
      if (snapColor) {
        sphere.material.color.copy(snapColor);
      } else {
        sphere.material.color.setHex(0xff0000);
      }
    }
  }

  /** Poll cursor pick; BIM may settle asynchronously via onSettled. */
  syncMarkerFromMouse(viewer, index, mouse) {
    const applyPick = (I) => this.applyPickToMarker(index, I);
    SharedUtils.getMousePointCloudIntersectionSettling(
      mouse,
      viewer.scene.getActiveCamera(),
      viewer,
      viewer.scene.pointclouds,
      { pickClipped: true },
      applyPick
    );
  }

  /**
   * When the pending marker is still at the scene origin (desktop bootstrap),
   * await Fragments BIM — sync pick alone misses without a point cloud.
   */
  async ensureMarkerSnappedFromMouse(viewer, index, mouse) {
    const pos = this.points[index]?.position;
    if (!pos || pos.lengthSq() > 1e-8) {
      return;
    }

    const I = await SharedUtils.getMousePointCloudIntersectionAsync(
      mouse,
      viewer.scene.getActiveCamera(),
      viewer,
      viewer.scene.pointclouds,
      { pickClipped: true }
    );
    if (I) {
      this.applyPickToMarker(index, I);
    }
  }

  getArea() {
    // Sum signed cross-product vectors over a triangle fan from p0, then take
    // the magnitude. Summing per-triangle magnitudes (as before) ignores
    // orientation and overcounts concave polygons.
    if (this.points.length < 3) {
      return 0;
    }
    const p0 = this.points[0].position;
    let nx = 0, ny = 0, nz = 0;
    for (let i = 1; i < this.points.length - 1; i++) {
      const p1 = this.points[i].position;
      const p2 = this.points[i + 1].position;
      const ax = p1.x - p0.x, ay = p1.y - p0.y, az = p1.z - p0.z;
      const bx = p2.x - p0.x, by = p2.y - p0.y, bz = p2.z - p0.z;
      nx += ay * bz - az * by;
      ny += az * bx - ax * bz;
      nz += ax * by - ay * bx;
    }
    return Math.sqrt(nx * nx + ny * ny + nz * nz) / 2;
  }

  getTotalDistance() {
    if (this.points.length === 0) {
      return 0;
    }

    let distance = 0;

    for (let i = 1; i < this.points.length; i++) {
      let prev = this.points[i - 1].position;
      let curr = this.points[i].position;
      let d = prev.distanceTo(curr);

      distance += d;
    }

    if (this.closed && this.points.length > 1) {
      let first = this.points[0].position;
      let last = this.points[this.points.length - 1].position;
      let d = last.distanceTo(first);

      distance += d;
    }

    return distance;
  }

  getAngleBetweenLines(cornerPoint, point1, point2) {
    let v1 = new THREE.Vector3().subVectors(
      point1.position,
      cornerPoint.position
    );
    let v2 = new THREE.Vector3().subVectors(
      point2.position,
      cornerPoint.position
    );

    // avoid the error printed by threejs if denominator is 0
    const denominator = Math.sqrt(v1.lengthSq() * v2.lengthSq());
    if (denominator === 0) {
      return 0;
    } else {
      return v1.angleTo(v2);
    }
  }

  getAngle(index) {
    if (this.points.length < 3 || index >= this.points.length) {
      return 0;
    }

    let previous =
      index === 0
        ? this.points[this.points.length - 1]
        : this.points[index - 1];
    let point = this.points[index];
    let next = this.points[(index + 1) % this.points.length];

    return this.getAngleBetweenLines(point, previous, next);
  }

  // updateAzimuth(){
  // 	// if(this.points.length !== 2){
  // 	// 	return;
  // 	// }

  // 	// const azimuth = this.azimuth;

  // 	// const [p0, p1] = this.points;

  // 	// const r = p0.position.distanceTo(p1.position);

  // }

  update() {
    if (this.points.length === 0) {
      return;
    } else if (this.points.length === 1) {
      let point = this.points[0];
      let position = point.position;
      this.spheres[0].position.copy(position);
      this.spheres[0].material.color.copy(this.sphereColorForPoint(point));

      // Hide edges and edge labels for single-point (Point tool) so no line is shown
      for (let edge of this.edges) {
        edge.visible = false;
      }
      for (let label of this.edgeLabels) {
        label.visible = false;
      }

      {
        // coordinate labels
        let coordinateLabel = this.coordinateLabels[0];

        let msg = SharedUtils.withMeasurementDisplayOffset(
          position,
          this.displayCoordOffset,
        )
          .map((p) => SharedUtils.addCommas(p.toFixed(2)))
          .join(' / ');
        coordinateLabel.setText(msg);

        coordinateLabel.visible = this.showCoordinates;
      }

      return;
    }

    let lastIndex = this.points.length - 1;

    let centroid = new THREE.Vector3();
    for (let i = 0; i <= lastIndex; i++) {
      let point = this.points[i];
      centroid.add(point.position);
    }
    centroid.divideScalar(this.points.length);

    for (let i = 0; i <= lastIndex; i++) {
      let index = i;
      let nextIndex = i + 1 > lastIndex ? 0 : i + 1;
      let previousIndex = i === 0 ? lastIndex : i - 1;

      let point = this.points[index];
      let nextPoint = this.points[nextIndex];
      let previousPoint = this.points[previousIndex];

      let sphere = this.spheres[index];

      if (this.name.startsWith('Height') && this.points.length === 2) {
        for (let edge of this.edges) {
          edge.visible = false;
        }
        for (let label of this.edgeLabels) {
          label.visible = false;
        }
      }

      // spheres
      sphere.position.copy(point.position);
      sphere.material.color.copy(this.sphereColorForPoint(point));

      {
        // edges
        this.connectEdges(index, nextPoint, point, this._closed, lastIndex);
      }

      {
        // edge labels
        if (index < this.edgeLabels.length)
          this.addEdgeLabel(index, lastIndex, nextPoint, point);
      }

      {
        // angle labels
        let angleLabel = this.angleLabels[i];
        let angle = this.getAngleBetweenLines(point, previousPoint, nextPoint);

        let dir = nextPoint.position.clone().sub(previousPoint.position);
        dir.multiplyScalar(0.5);
        dir = previousPoint.position
          .clone()
          .add(dir)
          .sub(point.position)
          .normalize();

        let dist = Math.min(
          point.position.distanceTo(previousPoint.position),
          point.position.distanceTo(nextPoint.position)
        );
        dist = dist / 9;

        let labelPos = point.position.clone().add(dir.multiplyScalar(dist));
        angleLabel.position.copy(labelPos);

        let msg =
          SharedUtils.addCommas((angle * (180.0 / Math.PI)).toFixed(1)) + '\u00B0';
        angleLabel.setText(msg);

        angleLabel.visible =
          this.showAngles &&
          (index < lastIndex || this.closed) &&
          this.points.length >= 3 &&
          angle > 0;
      }
    }

    {
      // update height stuff
      let heightEdge = this.heightEdge;
      heightEdge.visible = this.showHeight;
      this.heightLabel.visible = this.showHeight;
      this.baseLabel.visible = this.showHeight;

      if (this.showHeight && this.points.length === 2) {
        let [p0, p1] = this.points.map(p => p.position);
        let sorted = [p0.clone(), p1.clone()].sort((a, b) => a.z - b.z);
        let lowPoint = sorted[0];
        let highPoint = sorted[1];
        let min = lowPoint.z;
        let max = highPoint.z;
        let height = max - min;

        let start = new THREE.Vector3(highPoint.x, highPoint.y, min);
        let end = new THREE.Vector3(highPoint.x, highPoint.y, max);

        heightEdge.position.copy(lowPoint);
        heightEdge.geometry.setPositions([
          0, 0, 0,
          ...start.clone().sub(lowPoint).toArray(),
          ...start.clone().sub(lowPoint).toArray(),
          ...end.clone().sub(lowPoint).toArray(),
        ]);

        heightEdge.geometry.verticesNeedUpdate = true;
        heightEdge.geometry.computeBoundingSphere();
        heightEdge.computeLineDistances();

        const heightLabelPosition = start.clone().add(end).multiplyScalar(0.5);
        this.heightLabel.position.copy(heightLabelPosition);

        let suffix = '';
        let displayHeight = height;
        if (this.lengthUnit && this.lengthUnitDisplay) {
          displayHeight = (height / this.lengthUnit.unitspermeter) * this.lengthUnitDisplay.unitspermeter;
          suffix = this.lengthUnitDisplay.code;
        }

        this.heightLabel.setText(`h: ${SharedUtils.addCommas(displayHeight.toFixed(2))} ${suffix}`);

        const verticalPoint = this.points[0].position;
        const horizontalPoint = this.points[1].position;

        const xyDist = Math.sqrt(
          Math.pow(horizontalPoint.x - verticalPoint.x, 2) +
          Math.pow(horizontalPoint.y - verticalPoint.y, 2)
        );

        const baseMid = new THREE.Vector3(
          (verticalPoint.x + horizontalPoint.x) / 2,
          (verticalPoint.y + horizontalPoint.y) / 2,
          horizontalPoint.z
        );

        this.baseLabel.position.copy(baseMid);

        let displayXY = xyDist;
        if (this.lengthUnit && this.lengthUnitDisplay) {
          displayXY = (xyDist / this.lengthUnit.unitspermeter) * this.lengthUnitDisplay.unitspermeter;
        }

        this.baseLabel.setText(`l: ${SharedUtils.addCommas(displayXY.toFixed(2))} ${suffix}`);
        this.baseLabel.visible = true;
      }
    }

    {
      // update circle stuff
      const circleRadiusLabel = this.circleRadiusLabel;
      const circleRadiusLine = this.circleRadiusLine;
      const circleLine = this.circleLine;
      const circleCenter = this.circleCenter;

      const circleOkay = this.points.length === 3;

      circleRadiusLabel.visible = this.showCircle && circleOkay;
      circleRadiusLine.visible = this.showCircle && circleOkay;
      circleLine.visible = this.showCircle && circleOkay;
      circleCenter.visible = this.showCircle && circleOkay;

      if (this.showCircle && circleOkay) {
        const A = this.points[0].position;
        const B = this.points[1].position;
        const C = this.points[2].position;
        const AB = B.clone().sub(A);
        const AC = C.clone().sub(A);
        const N = AC.clone().cross(AB).normalize();

        const center = SharedUtils.computeCircleCenter(A, B, C);
        const radius = center.distanceTo(A);

        const scale = radius / 20;
        circleCenter.position.copy(center);
        circleCenter.scale.set(scale, scale, scale);

        //circleRadiusLine.geometry.vertices[0].set(0, 0, 0);
        //circleRadiusLine.geometry.vertices[1].copy(B.clone().sub(center));

        circleRadiusLine.geometry.setPositions([
          0,
          0,
          0,
          ...B.clone().sub(center).toArray(),
        ]);

        circleRadiusLine.geometry.verticesNeedUpdate = true;
        circleRadiusLine.geometry.computeBoundingSphere();
        circleRadiusLine.position.copy(center);
        circleRadiusLine.computeLineDistances();

        const target = center.clone().add(N);
        circleLine.position.copy(center);
        circleLine.scale.set(radius, radius, radius);
        circleLine.lookAt(target);

        circleRadiusLabel.visible = true;
        circleRadiusLabel.position.copy(
          center.clone().add(B).multiplyScalar(0.5)
        );
        let displayRadius = radius;
        let radiusSuffix = '';
        if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
          displayRadius = (radius / this.lengthUnit.unitspermeter) * this.lengthUnitDisplay.unitspermeter;
          radiusSuffix = this.lengthUnitDisplay.code;
        }
        circleRadiusLabel.setText(`r: ${SharedUtils.addCommas(displayRadius.toFixed(2))} ${radiusSuffix}`);
      }
    }

    {
      // update area label
      this.areaLabel.position.copy(centroid);
      this.areaLabel.visible = this.showArea && this.points.length >= 3;
      let area = this.getArea();

      let suffix = '';
      if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
        area =
          (area / Math.pow(this.lengthUnit.unitspermeter, 2)) *
          Math.pow(this.lengthUnitDisplay.unitspermeter, 2); //convert to square meters then to the square display unit
        suffix = this.lengthUnitDisplay.code;
      }

      let circumference = this.getTotalDistance();

      if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
        circumference =
          (circumference / this.lengthUnit.unitspermeter) *
          this.lengthUnitDisplay.unitspermeter;
        suffix = this.lengthUnitDisplay.code;
      }

      let txtArea = SharedUtils.addCommas(area.toFixed(1));
      let txtCircumference = SharedUtils.addCommas(circumference.toFixed(1));
      let msg = `${txtArea} ${suffix}\u00B2 \n ${txtCircumference} ${suffix}`;
      this.areaLabel.setText(msg);
    }

    {
      // update total distance label
      this.totalDistanceLabel.position.copy(centroid);
      this.totalDistanceLabel.visible =
        this.showTotalDistance && this.points.length >= 3;
      let totalDistance = this.getTotalDistance();

      let suffix = '';
      if (this.lengthUnit != null && this.lengthUnitDisplay != null) {
        totalDistance =
          (totalDistance / this.lengthUnit.unitspermeter) *
          this.lengthUnitDisplay.unitspermeter;
        suffix = this.lengthUnitDisplay.code;
      }

      let txtTotalDistance = SharedUtils.addCommas(totalDistance.toFixed(1));
      let msg = `${txtTotalDistance} ${suffix}`;
      this.totalDistanceLabel.setText(msg);
    }

    // this.updateAzimuth();
  }

  raycast(raycaster, intersects) {
    for (let i = 0; i < this.points.length; i++) {
      let sphere = this.spheres[i];

      sphere.raycast(raycaster, intersects);
    }

    // recalculate distances because they are not necessarely correct
    // for scaled objects.
    // see https://github.com/mrdoob/three.js/issues/5827
    // TODO: remove this once the bug has been fixed
    for (let i = 0; i < intersects.length; i++) {
      let I = intersects[i];
      I.distance = raycaster.ray.origin.distanceTo(I.point);
    }
    intersects.sort(function (a, b) {
      return a.distance - b.distance;
    });
  }

  get showCoordinates() {
    return this._showCoordinates;
  }

  set showCoordinates(value) {
    this._showCoordinates = value;
    this.update();
  }

  get showAngles() {
    return this._showAngles;
  }

  set showAngles(value) {
    this._showAngles = value;
    this.update();
  }

  get showCircle() {
    return this._showCircle;
  }

  set showCircle(value) {
    this._showCircle = value;
    this.update();
  }

  get showAzimuth() {
    return this._showAzimuth;
  }

  set showAzimuth(value) {
    this._showAzimuth = value;
    this.update();
  }

  get showEdges() {
    return this._showEdges;
  }

  set showEdges(value) {
    this._showEdges = value;
    this.update();
  }

  get showHeight() {
    return this._showHeight;
  }

  set showHeight(value) {
    this._showHeight = value;
    this.update();
  }

  get showArea() {
    return this._showArea;
  }

  set showArea(value) {
    this._showArea = value;
    this.update();
  }

  get showTotalDistance() {
    return this._showTotalDistance;
  }

  set showTotalDistance(value) {
    this._showTotalDistance = value;
    this.update();
  }

  get closed() {
    return this._closed;
  }

  set closed(value) {
    this._closed = value;
    this.update();
  }

  get showDistances() {
    return this._showDistances;
  }

  set showDistances(value) {
    this._showDistances = value;
    this.update();
  }
}
